import { Component, OnInit } from "@angular/core";
import { VisitorReasonRequest } from "../shared/VisitorReasonRequest";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_ReasonMaintenance } from "../shared/data.service";

@Component({
	selector: "app-ms-edit-visitor-reason",
	templateUrl: "./ms-edit-visitor-reason.component.html",
	styleUrls: ["./ms-edit-visitor-reason.component.css"],
})
export class MsEditVisitorReasonComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private visitorService: DataService_ReasonMaintenance
	) {}

	ngOnInit(): void {
		this.VisitorReasonID = this.dialogConfig.data.VisitorReasonID;
		this.VisitorReasonDesc = this.dialogConfig.data.VisitorReasonDesc;
	}

	/////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////
	VisitorReasonID: number = -1;
	VisitorReasonDesc: string = "";
	errorMessage: string = "";
	Processing: boolean = false;
	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		if (this.VisitorReasonDesc == undefined || this.VisitorReasonDesc.trim().length == 0) {
			this.errorMessage = "Enter reason description";
			return;
		}

		if (this.VisitorReasonDesc.length > 50) {
			this.errorMessage = "Reason description cannot be more than 50 characters. NOTE: Reasons show up as buttons in the app";
			return;
		}

		//
		// Check Name Already Used
		//
		this.Processing = true;

		var parms: VisitorReasonRequest = {
			VisitorReasonID: this.VisitorReasonID,
			VisitorReasonDesc: this.VisitorReasonDesc,
		};

		var result = this.visitorService.VisitorReasonInUse(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.onFinishAdd(parms);
				} else {
					this.Processing = false;

					//Fail Dialog
					this.confirmationService.confirm({
						key: "confirmedit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the visit reason: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onFinishAdd(parms: VisitorReasonRequest) {
		var result = this.visitorService.VisitorReasonUpdate(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Visit Reason was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the visit reason: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////
	IsLoading() {
		return this.Processing == true;
	}
	/////////////////////////////////////////////////////////
}
